import React from 'react';

import { BirreteApps, Refresh } from '@crehana/icons/outline';
import { useTranslation } from '@crehana/i18n';

const MembershipBenefits: React.FC<{
  renovationMessage?: string;
  className?: string;
}> = ({ renovationMessage, className }) => {
  const { t } = useTranslation();

  return (
    <ul className={className}>
      <li className="mb-16">
        <p className="flex items-cneter">
          <BirreteApps
            size={24}
            ignoreColor
            className="fill-current text-yellow-main"
          />
          <span className="ml-12 font-body3">{t('PREMIUM_BENEFIT_1')}</span>
        </p>
      </li>
      <li className="mb-16">
        <p className="flex items-cneter">
          <Refresh
            size={24}
            ignoreColor
            className="fill-current text-yellow-main"
          />
          <span className="ml-12 font-body3">{renovationMessage}</span>
        </p>
      </li>
    </ul>
  );
};

export default MembershipBenefits;
